// @ts-nocheck

export const simpleArrayMatch = function (array1, array2) {
  return array1.length === array2.length && array1.every((val, index) => val === array2[index]);
};
